import {Link, useLocation} from 'react-router-dom'
import classNames from 'classnames'
import {useEffect, useState} from 'react'
import './index.scss'
import {useSelector} from 'react-redux'
import {isSelfHosted} from '../../../utils/newFeature'

const tabs = [
    {
        key: 'integrations',
        url: '/integrations',
        label: 'Integrations',
        hideIfFeatureDisabled: isSelfHosted()
    },
    {
        key: 'team_channels',
        url: '/notifications/team',
        label: 'Team channels'
    },
    {
        key: 'personal_channels',
        url: '/notifications/personal',
        label: 'Personal channels'
    }
]

const IntegrationTeamMenu = () => {
    const [activeTab, setActiveTab] = useState(null)
    const {pathname} = useLocation()
    const isDarkMode = useSelector(state => state.sidebar.isDarkMode)

    useEffect(() => {
        setActiveTab(tabs.find(({url}) => pathname?.includes(url))?.key)
    }, [pathname])

    return (
        <div className={classNames('menu', {
            dark: isDarkMode
        })}>
            {tabs.map(({key, url, label, hideIfFeatureDisabled}) => (
                !hideIfFeatureDisabled && <span key={key} className={classNames('menu-tab', {'active': activeTab === key})}>
                    <Link to={url}>{label}</Link>
                </span>
            ))}
        </div>
    )
}

export default IntegrationTeamMenu
